import React, { useState, useEffect } from 'react';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { ExercisesCard } from '@/app/screens/exercises/exercises-card';
import { t } from 'i18next';
import { CardWrapper } from '@/components/ui/card';

export function CourseClassroomQuestionBooks(props) {
  const { selectedItemId, setEmptyTabs, questionIds } = props;
  const client = useClient();
  const [loading, setLoading] = useState(true);
  const [questionBooks, setQuestionBooks] = useState([]);

  const getQuestionBooks = async () => {
    setLoading(true);
    const url = `question_books?filter[visibility]=train`;
    const { data, error } = await client.fetch(url);
    setLoading(false);

    if (error) {
      toast.error(t('toast.errorGetQuestionBooks'));
    } else {
      const filteredData = data.filter(q => questionIds?.includes(q.id));
      setQuestionBooks(filteredData);
      if (filteredData.length > 0) {
        setEmptyTabs(false);
      }
    }
  };

  useEffect(() => {
    if (selectedItemId) {
      getQuestionBooks();
    }
  }, [selectedItemId, questionIds]);

  return loading ? (
    <Loader />
  ) : questionBooks.length > 0 ? (
    (questionBooks || []).map(book => (
      <CardWrapper key={book.id}>
        <ExercisesCard book={book} />
      </CardWrapper>
    ))
  ) : (
    <EmptyState
      type="content"
      title="Sem conteúdo"
    />
  );
}
